const RELOAD_FLAG = "taxboard:chunk-reload-attempted";

function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  const name = error instanceof Error ? error.name : "";
  return (
    name === "ChunkLoadError" ||
    /Loading chunk [\d]+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message)
  );
}

export function recoverFromChunkError(error: unknown): boolean {
  if (typeof window === "undefined") return false;
  if (!isChunkLoadError(error)) return false;
  if (window.sessionStorage.getItem(RELOAD_FLAG)) return false;

  window.sessionStorage.setItem(RELOAD_FLAG, "1");
  window.location.reload();
  return true;
}

export function clearChunkErrorFlag() {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(RELOAD_FLAG);
}
